import BuildCircleOutlinedIcon from '@mui/icons-material/BuildCircleOutlined';
import aiMusicGenerator from 'services/locales/en/aiMusicGenerator';
import GenerateIcon from 'assets/icons/GenerateIcon';
import AddToLibrary from './icons/AddToLibrary';

export const stepsArray = [
  {
    icon: BuildCircleOutlinedIcon,
    title: aiMusicGenerator.stepGuide.titles.buildYourSong,
    description: aiMusicGenerator.stepGuide.descriptions.selecGenre,
  },
  {
    icon: GenerateIcon,
    title: aiMusicGenerator.stepGuide.titles.generateTracks,
    description: aiMusicGenerator.stepGuide.descriptions.getNewMusic,
  },
  {
    icon: AddToLibrary,
    title: aiMusicGenerator.stepGuide.titles.saveAndDownload,
    description: aiMusicGenerator.stepGuide.descriptions.selectYourFavorites,
  },
];
